import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  it: {
    translation: {
      nav: { locali: 'Locali', zone: 'Zone', admin: 'Admin', collabora: 'Collabora' },
      hero: {
        title: 'Vivi la notte di Roma',
        subtitle: 'Le serate, i club e gli eventi più esclusivi della Capitale. Trova il tuo prossimo weekend in pochi click.',
        searchTitle: 'Cerca la tua serata',
      },
      filters: {
        day: 'Giorno', zone: 'Zona', venue: 'Locale',
        anyZone: 'Tutte le zone', anyVenue: 'Tutti i locali', any: 'Qualsiasi',
        search: 'Cerca', reset: 'Reset', pickDay: 'Seleziona giorno', anyDay: 'Qualsiasi giorno',
      },
      sections: { featured: 'Eventi Top', upcoming: 'Prossimi eventi', zones: 'Esplora le zone', topVenues: 'Locali in evidenza' },
      empty: { events: 'Nessun evento trovato per questi filtri.', eventsCta: 'Reset filtri', venues: 'Nessun locale presente al momento.' },
      event: {
        date: 'Data', time: 'Orario', venue: 'Locale', zone: 'Zona',
        artists: 'Artisti', genre: 'Genere', price: 'Prezzo ingresso',
        details: 'Dettagli evento', location: 'Dove',
        buy: 'ACQUISTA', table: 'PRENOTA TAVOLO',
        viewMore: 'Vedi dettagli', featuredBadge: 'TOP', priveBadge: 'Privé',
      },
      zone: {
        title: 'Serate a Roma',
        intro: "Scopri tutti gli eventi e i locali nella zona di {{zone}}. Le migliori serate, club e party selezionati per te.",
        venuesInZone: 'Locali in zona', eventsInZone: 'Eventi in {{zone}}',
      },
      locale: {
        title: 'Locali a Roma',
        upcomingEvents: 'Prossimi eventi al {{name}}',
        gallery: 'Gallery', about: 'Il locale', address: 'Indirizzo', phone: 'Telefono', website: 'Sito web',
      },
      newsletter: {
        bigTitle: 'Rimani aggiornato',
        text: "Iscriviti alla newsletter per ricevere ogni giovedì i migliori eventi del weekend e gli inviti in lista.",
        placeholder: 'La tua email',
        button: 'ISCRIVITI',
        success: 'Grazie! Iscrizione completata. Ci sentiamo giovedì.',
      },
      collabora: {
        navLink: 'Collabora con noi',
        title: 'Collabora con Noi',
        intro: "Vuoi portare più clienti al tuo locale? RomaDiNotte è il portale numero uno per gli eventi. Contattaci per inserire il tuo evento in prima pagina o per vendere i biglietti tramite il nostro circuito.",
        formTitle: 'Inviaci la tua richiesta',
        nomeLocale: 'Nome Locale / PR', referente: 'Referente', email: 'Email', telefono: 'Telefono',
        tipoRichiesta: 'Tipo di Richiesta', messaggio: 'Messaggio',
        types: {
          vendita: 'Vendita Biglietti in Affiliazione',
          evidenza: 'Mettere Evento in Evidenza',
          altro: 'Altro',
        },
        submit: 'Invia richiesta',
        success: 'Richiesta inviata! Ti contatteremo a breve.',
      },
      footer: {
        about: "Il portale dedicato alla nightlife di Roma. Eventi, locali, serate.",
        zonesTitle: 'Zone', infoTitle: 'Informazioni', contact: 'Contatti', rights: 'Tutti i diritti riservati.',
        newsletterTitle: 'Newsletter',
      },
      common: { loading: 'Caricamento...', back: 'Indietro', viewAll: 'Vedi tutti', notFound: 'Pagina non trovata', backHome: 'Torna alla home', save: 'Salva', cancel: 'Annulla' },
    }
  },
  en: {
    translation: {
      nav: { locali: 'Venues', zone: 'Areas', admin: 'Admin', collabora: 'Partner' },
      hero: { title: 'Live the Roman night', subtitle: "Rome's most exclusive parties, clubs and events. Find your next weekend in a few clicks.", searchTitle: 'Find your night' },
      filters: { day: 'Day', zone: 'Area', venue: 'Venue', anyZone: 'All areas', anyVenue: 'All venues', any: 'Any', search: 'Search', reset: 'Reset', pickDay: 'Pick a day', anyDay: 'Any day' },
      sections: { featured: 'Top Events', upcoming: 'Upcoming events', zones: 'Explore areas', topVenues: 'Featured venues' },
      empty: { events: 'No events match these filters.', eventsCta: 'Reset filters', venues: 'No venues available yet.' },
      event: { date: 'Date', time: 'Time', venue: 'Venue', zone: 'Area', artists: 'Artists', genre: 'Genre', price: 'Entry price', details: 'Event details', location: 'Where', buy: 'BUY TICKET', table: 'BOOK TABLE', viewMore: 'View details', featuredBadge: 'TOP', priveBadge: 'VIP' },
      zone: { title: 'Nights in Rome', intro: 'Discover all events and venues in {{zone}}. The best parties, clubs and events selected for you.', venuesInZone: 'Venues in area', eventsInZone: 'Events in {{zone}}' },
      locale: { title: 'Venues in Rome', upcomingEvents: 'Upcoming events at {{name}}', gallery: 'Gallery', about: 'About the venue', address: 'Address', phone: 'Phone', website: 'Website' },
      newsletter: {
        bigTitle: 'Stay in the loop',
        text: 'Subscribe to our newsletter to get the best weekend events and guest list invites every Thursday.',
        placeholder: 'Your email', button: 'SUBSCRIBE',
        success: 'Thank you! Subscription completed. See you on Thursday.',
      },
      collabora: {
        navLink: 'Partner with us', title: 'Partner with Us',
        intro: "Want to bring more clients to your venue? RomaDiNotte is the #1 events portal in Rome. Contact us to feature your event or sell tickets through our network.",
        formTitle: 'Send us your request',
        nomeLocale: 'Venue / PR Name', referente: 'Contact name', email: 'Email', telefono: 'Phone',
        tipoRichiesta: 'Request type', messaggio: 'Message',
        types: { vendita: 'Affiliate Ticket Sales', evidenza: 'Feature my Event', altro: 'Other' },
        submit: 'Send request', success: 'Request sent! We will contact you soon.',
      },
      footer: { about: 'The nightlife portal for Rome. Events, venues, parties.', zonesTitle: 'Areas', infoTitle: 'Information', contact: 'Contact', rights: 'All rights reserved.', newsletterTitle: 'Newsletter' },
      common: { loading: 'Loading...', back: 'Back', viewAll: 'See all', notFound: 'Page not found', backHome: 'Back home', save: 'Save', cancel: 'Cancel' }
    }
  }
};

i18n.use(LanguageDetector).use(initReactI18next).init({
  resources, fallbackLng: 'it', supportedLngs: ['it', 'en'],
  detection: { order: ['localStorage', 'navigator'], caches: ['localStorage'] },
  interpolation: { escapeValue: false },
});

export default i18n;
